import { type HeatPumpConstructorItem_OutputType } from '@shared/generated';

export const isHeatPumpConstructorItem = (
  item: object
): item is HeatPumpConstructorItem_OutputType => {
  if (item === null || item === undefined) {
    return false;
  }
  return 'heat_pump_catalog' in item;
};
